<template>
  <section v-if="groups.hasItems">
    <div class="group-container">
      <div v-for="group in groups.get()" :key="group.type" class="m-b-20">
        <SpotlightGroup :group="group" :show-type-title="showTypeTitle" v-on="$listeners" />
      </div>
    </div>
  </section>
</template>

<script>
import { SpotlightGroupCollection } from '@/modules/spotlight/models/SpotlightGroupCollection';
import SpotlightGroup from '@/modules/spotlight/components/presentational/SpotlightGroup.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightGroups',
  components: { SpotlightGroup },
  props: {
    groups: SpotlightGroupCollection,
    showTypeTitle: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.group-container {
  position: absolute;
  top: var(--ce-128px);
  padding-top: var(--ce-10px);
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: var(--ce-radius-large);
}

img {
  height: var(--ce-200px);
}
</style>
